export default __webpack_public_path__ + "static/media/talit-tfilin-mission.e5e7d173.png";